import { Component } from '@angular/core';

@Component({
    selector: 'app-internal',
    templateUrl: './internal.component.html',
    styleUrl: './internal.component.scss',
    standalone: false
})
export class InternalComponent {

}
